<template>
  <div class="main-container">
    <div class="container" ref="printArea">
      <!-- Header -->
      <div class="row">
        <div class="col-lg-12 text-center my-4">
          <h1>{{ $t('schedule.titleSeni') }}</h1>
        </div>
      </div>

      <!--
        PENYARING — satu dropdown per sumbu, kosong berarti semua.

        Bentuk lamanya kotak centang, dan dua paruhnya saling bertentangan:
        tanggal dan gelanggang memperlakukan daftar kosong sebagai "tidak
        ada yang lolos", sedangkan kategori dan pool
        memperlakukannya sebagai "semua lolos". Menghapus centang terakhir
        pada tanggal karena itu mengosongkan seluruh halaman — persis
        seperti jadwal yang hilang, tanpa satu pun keterangan.
      -->
      <div class="row filter mb-3">
        <div class="col-lg-12">
          <div class="jadwal-saring-baris">
            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterDate') }}</span>
              <select v-model="filterTanggal" class="form-select">
                <option value="">{{ $t('schedule.allDates') }}</option>
                <option v-for="date in allDates" :key="date" :value="date">
                  {{ formatLongDate(date) }}
                </option>
              </select>
            </label>

            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterCategory') }}</span>
              <select v-model="filterKategori" class="form-select">
                <option value="">{{ $t('schedule.allCategories') }}</option>
                <option v-for="category in allCategories" :key="category" :value="category">
                  {{ category }}
                </option>
              </select>
            </label>

            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterArena') }}</span>
              <select v-model="filterArena" class="form-select">
                <option value="">{{ $t('schedule.allArenas') }}</option>
                <option v-for="arena in allArenaNames" :key="arena" :value="arena">
                  {{ arena }}
                </option>
              </select>
            </label>

            <label class="jadwal-saring-item">
              <span class="fw-bold">{{ $t('schedule.filterPool') }}</span>
              <select v-model="filterPool" class="form-select">
                <option value="">{{ $t('schedule.allPools') }}</option>
                <option v-for="pool in allPoolNames" :key="pool" :value="pool">
                  {{ pool }}
                </option>
              </select>
            </label>

            <button
              v-if="adaSaringAktif"
              type="button"
              class="btn btn-outline-secondary jadwal-saring-reset"
              @click="kosongkanSaring"
            >
              <i class="bi bi-x-lg"></i> Tampilkan semua
            </button>
          </div>
        </div>
      </div>

      <!-- Schedule Table Section -->
      <div class="row bg-white">
        <div class="col-lg-12">
          <div class="table-responsive">

            <div v-if="memuat" class="text-center text-muted my-5">
              <div class="spinner-border" role="status"></div>
              <div class="mt-2">Memuat jadwal seni…</div>
            </div>

            <div v-else-if="galat" class="alert alert-danger my-4">
              <strong>Jadwal seni gagal dimuat.</strong>
              <div>{{ galat }}</div>
            </div>

            <!-- Dibedakan: memang belum ada, atau ada tapi tersaring habis. -->
            <div v-else-if="!scheduleData.length" class="text-center text-muted my-5">
              <h5>Belum ada jadwal pertandingan seni yang tersedia.</h5>
              <p class="mb-0">Jadwal akan muncul setelah panitia menyusunnya.</p>
            </div>

            <div v-else-if="!Object.keys(groupedByDate).length" class="text-center text-muted my-5">
              <h5>Tidak ada partai yang cocok dengan penyaring.</h5>
              <button type="button" class="btn btn-outline-secondary mt-2" @click="kosongkanSaring">
                <i class="bi bi-x-lg"></i> Tampilkan semua
              </button>
            </div>

            <!-- Loop per Tanggal -->
            <div v-for="(arenas, date) in groupedByDate" :key="date">
              <div v-for="(groupList, arenaName) in arenas" :key="arenaName">
                <div v-if="groupList && groupList.length">

                  <!-- Header Jadwal (per tanggal & arena) -->
                  <div class="row align-items-center mb-4">
                    <div class="col-3 d-flex align-items-center gap-3">
                      <img src="@/assets/images/ipsi.png" alt="Logo IPSI" class="logo-ipsi" />
                    </div>
                    <div class="col-6 text-center">
                      <h4 class="text-dark mb-2 text-uppercase fw-bold">JADWAL {{ arenaName }}</h4>
                      <h4 class="text-dark mb-2 text-uppercase fw-bold">
                        {{ groupList[0]?.tournament_name || '-' }}
                      </h4>
                      <div class="text-dark text-uppercase fw-bold">
                        {{ formatLongDate(date) }}
                      </div>
                    </div>
                    <div class="col-3 text-end">
                      <button class="btn btn-outline-primary btn-sm" @click="downloadSchedule(groupList[0], date)">
                        <i class="bi bi-download me-1"></i> Download Schedule
                      </button>
                    </div>
                  </div>

                  <!-- ===================== BATTLE: SATU TABEL GABUNGAN ===================== -->
                  <!-- === BATTLE: satu tabel gabungan per arena === -->
                  <template v-if="getArenaBattleRows(groupList).length">
                    <table class="table table-striped mb-5">
                      <thead>
                        <tr class="table-sub-header">
                          <th>PARTAI</th>
                          <th>Babak</th>
                          <th>Kelas</th>
                          <th class="text-center red">Merah</th>
                          <th class="text-center blue">Biru</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in getArenaBattleRows(groupList)" :key="'b-'+row.order">
                          <td>{{ row.order }}</td>
                          <td class="text-uppercase">{{ row.round_label || '-' }}</td>
                          <td class="text-uppercase">{{ row.class_label || '-' }}</td>

                          <td class="corner-red">
                            <template v-if="hasAny(row.red)">
                              <div class="names" v-if="row.red?.names">{{ row.red?.names }}</div>
                              <div class="contingent" v-if="row.red?.contingent">{{ row.red?.contingent }}</div>
                            </template>
                            <template v-else-if="row.source_red_order">
                              Pemenang Partai #{{ row.source_red_order }}
                            </template>
                            <template v-else>-</template>
                          </td>

                          <td class="corner-blue">
                            <template v-if="hasAny(row.blue)">
                              <div class="names" v-if="row.blue?.names">{{ row.blue?.names }}</div>
                              <div class="contingent" v-if="row.blue?.contingent">{{ row.blue?.contingent }}</div>
                            </template>
                            <template v-else-if="row.source_blue_order">
                              Pemenang Partai #{{ row.source_blue_order }}
                            </template>
                            <template v-else>-</template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>

                  <!-- ===================== NON-BATTLE: PER POOL (seperti biasa) ===================== -->
                  <template v-for="tb in getNonBattleTables(groupList)" :key="arenaName+'-'+tb.key">
                    <table class="table table-striped mb-5">
                      <thead>
                        <tr class="table-sub-header">
                          <th>PARTAI</th>
                          <th>Kontingen</th>
                          <th :colspan="getAthleteColspan(tb)">Nama Atlet</th>
                        </tr>
                        <tr>
                          <th :colspan="getPoolColspan(tb)" class="text-center fw-bold text-uppercase table-header">
                            {{ tb.title.category }}
                            {{ tb.title.age?.toUpperCase() || '-' }} - {{ tb.title.pool }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="entry in tb.rows" :key="'nb-'+entry.id">
                          <td>{{ entry.match_order ?? entry.order ?? '-' }}</td>
                          <td>{{ entry.contingent?.name || '-' }}</td>

                          <template v-if="entry.match_type === 'seni_tunggal'">
                            <td>{{ entry.team_member1?.name || '-' }}</td>
                          </template>
                          <template v-else-if="entry.match_type === 'seni_ganda'">
                            <td>{{ entry.team_member1?.name || '-' }}</td>
                            <td>{{ entry.team_member2?.name || '-' }}</td>
                          </template>
                          <template v-else-if="entry.match_type === 'seni_regu'">
                            <td>{{ entry.team_member1?.name || '-' }}</td>
                            <td>{{ entry.team_member2?.name || '-' }}</td>
                            <td>{{ entry.team_member3?.name || '-' }}</td>
                          </template>
                          <template v-else>
                            <td>{{ entry.team_member1?.name || '-' }}</td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </template>


                </div>
              </div>
            </div>




          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import axios from "axios";
import API from "@/config/api";
import html2pdf from "html2pdf.js";

export default {
  name: "SchedulePage",
  /*
   * Slug bisa datang dari DUA arah:
   *   - alamat /schedule/<slug>/tanding  (tautan yang dibagikan pelatih)
   *   - prop, saat komponen ini dipasang di dalam halaman Jadwal terpadu
   *
   * Prop diutamakan. Tanpa ini, memasangnya di halaman Jadwal akan membaca
   * $route.params.slug yang kosong, dan tabelnya selamanya tidak terisi.
   */
  props: {
    slug: { type: String, default: '' },
  },

  watch: {
    // Berganti acara lewat penyaring tidak mengganti komponen, jadi
    // datanya harus diambil ulang secara manual.
    slugAktif(baru) {
      if (baru) this.fetchSchedules();
    },
  },
  data() {
    return {
      scheduleData: [],
      memuat: true,
      galat: null,

      allDates: [],
      allArenaNames: [],
      allPoolNames: [],

      /*
       * Satu nilai per sumbu; string kosong berarti "semua".
       *
       * INI YANG DULU MENGOSONGKAN HALAMAN
       * Sebelumnya daftar kategori dipatok di kode:
       *
       *     selectedCategoryFilters: ['Tunggal', 'Ganda', 'Regu', 'Solo Kreatif']
       *
       * Nama kategori yang dikirim server adalah nama barisnya —
       * "Tunggal Prestasi", "Ganda Pemasalan", dan seterusnya. Tidak satu
       * pun cocok dengan daftar di atas, jadi SETIAP kelompok tersaring
       * habis. Yang tersisa cuma kepala tabel: nama gelanggang, nama acara,
       * tanggal, lalu ruang kosong.
       *
       * Daftar itu juga tidak pernah diperbarui dari data — jadi kategori
       * apa pun yang ditambahkan panitia tidak akan pernah lolos.
       */
      filterTanggal: '',
      filterKategori: '',
      filterArena: '',
      filterPool: '',

      tournamentName: '',
    };
  },

  computed: {
    /*
     * Slug bisa datang dari alamat (/schedule/<slug>/tanding) atau dari
     * prop, saat komponen ini dipasang di halaman Jadwal terpadu.
     * Prop diutamakan.
     */
    slugAktif() {
      return this.slug || this.$route.params.slug || '';
    },

    /* Daftar pilihan dibangun DARI data, bukan ditulis di kode. */
    allCategories() {
      const daftar = new Set();
      this.scheduleData.forEach(e =>
        (e.groups ?? []).forEach(g => { if (g.category) daftar.add(g.category); })
      );
      return [...daftar].sort();
    },

    adaSaringAktif() {
      return Boolean(
        this.filterTanggal || this.filterKategori || this.filterArena || this.filterPool
      );
    },

    groupedByDate() {
      // Kosong berarti "semua" — untuk SEMUA sumbu, tanpa kecuali.
      const lolos = (dipilih, nilai) => !dipilih || dipilih === nilai;

      const grouped = {};

      this.scheduleData.forEach(entry => {
        const date = entry.scheduled_date;
        const arena = entry.arena_name;

        if (!lolos(this.filterTanggal, date) || !lolos(this.filterArena, arena)) {
          return;
        }

        const kelompok = (entry.groups ?? [])
          .filter(group =>
            lolos(this.filterKategori, group.category) &&
            (!this.filterPool || (group.pools ?? []).some(p => p.name === this.filterPool))
          )
          .map(group => ({
            ...group,
            pools: this.filterPool
              ? (group.pools ?? []).filter(p => p.name === this.filterPool)
              : (group.pools ?? []),
            arena_name: arena,
            tournament_name: entry.tournament_name,
          }));

        /*
         * Gelanggang tanpa kelompok yang lolos TIDAK ditampilkan.
         *
         * Versi sebelumnya menyisipkan baris kosong sebagai gantinya, dan
         * itulah asal keluhan "hanya kepalanya saja yang muncul": kepala
         * tabel tercetak lengkap dengan nama gelanggang dan tanggal, lalu
         * tidak ada satu pun baris di bawahnya, tanpa penjelasan apa pun.
         */
        if (!kelompok.length) return;

        if (!grouped[date]) grouped[date] = {};
        if (!grouped[date][arena]) grouped[date][arena] = [];
        grouped[date][arena].push(...kelompok);
      });

      return grouped;
    },





  },

  mounted() {
    this.fetchSchedules();

  },

  methods: {

    hasAny(side) {
      return !!(side && (side.contingent || side.names));
    },


     getNonBattlePools(categoryGroup) {
        const pools = (categoryGroup?.pools || []).map(p => {
          const matches = (p.matches || [])
            .filter(m => m?.mode !== 'battle')
            .sort((a, b) => (a.order ?? a.match_order ?? 0) - (b.order ?? b.match_order ?? 0));
          return { name: p.name, matches };
        });
        return pools.filter(p => p.matches.length > 0);
      },

    _matchTypeToCategory(mt) {
      switch (mt) {
        case 'seni_tunggal': return 'TUNGGAL';
        case 'seni_ganda':   return 'GANDA';
        case 'seni_regu':    return 'REGU';
        case 'solo_kreatif': return 'SOLO KREATIF';
        default:             return 'KATEGORI';
      }
    },

    /**
       * Gabung nama atlet utk tiap side:
       * - Tunggal: 1 nama
       * - Ganda/Regu: "nama1, nama2[, nama3]"
       * - Jika slot kosong (misal BYE), tampilkan 'BYE'
       */

    _joinMemberNames(entry) {
      if (!entry) return '';
      const names = [];
      if (entry.team_member1?.name) names.push(entry.team_member1.name);
      if (entry.team_member2?.name) names.push(entry.team_member2.name);
      if (entry.team_member3?.name) names.push(entry.team_member3.name);
      return names.join(', ');
    },

    // === ranking label babak (buat tau "sebelumnya" itu apa)
    _roundRank(label) {
      const L = String(label || '').toLowerCase();
      if (L.includes('final') && !L.includes('semi') && !L.includes('perempat') && !L.includes('delapan')) return 5; // Final
      if (L.includes('semifinal'))    return 4;
      if (L.includes('perempat'))     return 3;
      if (L.includes('perdelapan') || L.includes('16')) return 2;
      if (L.includes('penyisihan') || L.includes('babak')) return 1;
      return 1; // fallback
    },

    // === TABLE BATTLE ARENA-LEVEL: diratakan, urut match_order, isi winner untuk slot kosong

    

  getArenaBattleRows(groupList) {
  const toStr = v => (v ?? '').toString().trim();
  const byOrder = new Map(); // key = match_order, val = row gabungan (blue+red)

  // ⬅️ PERBAIKAN PENTING: iterasi ARRAY groupList
  for (const group of (groupList || [])) {
    const category = toStr(group?.category);        // ex: 'Tunggal Prestasi'
    const age      = toStr(group?.age_category);    // ex: 'REMAJA'

    for (const pool of (group?.pools || [])) {
      for (const m of (pool?.matches || [])) {
        if (!m || m.mode !== 'battle') continue;

        const order = m.match_order ?? m.order;
        if (order == null) continue; // harus ada nomor partai

        // siapkan row kalau belum ada
        if (!byOrder.has(order)) {
          const classLabel =
            toStr(m.class_label) ||
            [category, age].filter(Boolean).join(' ').toUpperCase();

          byOrder.set(order, {
            order,
            round_label: toStr(m.round_label),
            class_label: classLabel,
            blue: { names: null, contingent: null },
            red:  { names: null, contingent: null },
            time: m.match_time ?? null,
            score: m.final_score ?? m.score ?? null,

            // pointer “Pemenang Partai #X” per corner
            source_blue_order: null,
            source_red_order:  null,
          });
        }

        const row = byOrder.get(order);

        // isi info dasar kalau belum terisi
        if (!row.round_label && m.round_label) row.round_label = toStr(m.round_label);
        if (!row.time && m.match_time)         row.time        = m.match_time;
        if (!row.score && (m.final_score ?? m.score)) row.score = m.final_score ?? m.score;

        // build sisi dari data match ini
        const sideObj = this.buildCornerObject(m);

        // pointer asal partai untuk fallback text
        const fromOrder =
          m.source_blue_order ?? m.source_red_order ??
          m.source_from_order ?? m.winner_of_order ??
          m.source_order ?? m.prev_order ?? null;

        const corner = toStr(m.corner).toLowerCase();
        if (corner === 'blue') {
          row.blue = sideObj;
          if (!row.source_blue_order) row.source_blue_order = m.source_blue_order ?? fromOrder;
        } else if (corner === 'red') {
          row.red = sideObj;
          if (!row.source_red_order)  row.source_red_order  = m.source_red_order  ?? fromOrder;
        } else {
          // fallback kalau corner kosong: tebak parity (jarang terjadi)
          if ((order % 2) === 0) {
            row.red = sideObj;
            if (!row.source_red_order) row.source_red_order = m.source_red_order ?? fromOrder;
          } else {
            row.blue = sideObj;
            if (!row.source_blue_order) row.source_blue_order = m.source_blue_order ?? fromOrder;
          }
        }
      }
    }
  }

  // hasil akhir urut berdasarkan nomor partai
  return Array.from(byOrder.values()).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
},

buildCornerObject(m) {
  const names = [];
  if (m?.team_member1?.name) names.push(m.team_member1.name);
  if (m?.team_member2?.name) names.push(m.team_member2.name);
  if (m?.team_member3?.name) names.push(m.team_member3.name);

  return {
    names: names.length ? names.join(' / ') : null,
    contingent: m?.contingent?.name || null,
  };
},




  getArenaBattleRows__backup(groupList = []) {
  // util kecil
  const toStr = (v) => (v ?? '').toString().trim();
  const sanitize = (v) => {
    const s = toStr(v);
    if (!s) return '';
    const u = s.toUpperCase();
    return (u === '-' || u === '—' || u === 'N/A' || u === 'NULL' || u === 'UNDEFINED' || u === 'BYE' || u === 'TBD')
      ? ''
      : s;
  };
  // key = order (global di arena), val = row gabungan (blue+red)
  const byOrder = new Map();

  for (const group of (groupList || [])) {
    const category = toStr(group?.category);         // ex. 'Tunggal Prestasi'
    const pools    = group?.pools || [];

    for (const pool of pools) {
      const matches = pool?.matches || [];

      for (const m of matches) {
        if (m?.mode !== 'battle') continue;

        const order = (m.order ?? m.match_order);
        if (order == null) continue; // mesti ada nomor partai

        if (!byOrder.has(order)) {
          byOrder.set(order, {
            order,
            round_label: toStr(m.round_label),
            class_label: '',                 // diisi sekali per order
            blue: { contingent: '', names: '' },
            red:  { contingent: '', names: '' },
            time: m.match_time || '',
            score: m.final_score || '',
          });
        }

        const row = byOrder.get(order);

        // round label (ambil yang terisi)
        if (!row.round_label && m.round_label) {
          row.round_label = toStr(m.round_label);
        }

        // CLASS LABEL: "TUNGGAL PRESTASI REMAJA" (uppercase)
        if (!row.class_label) {
          const age = toStr(m?.pool?.age_category?.name) || toStr(group?.age_category);
          const cls = [category, age].filter(Boolean).join(' ');
          row.class_label = cls.toUpperCase();
        }

        // NAMA2 atlet (gabung), TANPA fallback '-'
        const namesJoined = [
          m?.team_member1?.name,
          m?.team_member2?.name,
          m?.team_member3?.name,
        ].filter(Boolean).join(', ');
        let names = sanitize(namesJoined);

        // Kalau kosong, coba pakai info "pemenang partai #<no>"
        const winnerOrder =
          m?.winner_of_order ??
          m?.winner_from_order ??
          m?.source_order ??
          m?.from_order ??
          m?.prev_order ??
          null;
        if (!names && winnerOrder) {
          names = `Pemenang partai #${winnerOrder}`;
        }

        // Kontingen TANPA fallback '-'
        const cont = sanitize(m?.contingent?.name ?? m?.contingent_name);

        const side = { contingent: cont, names };
        const corner = toStr(m?.corner).toLowerCase();

        if (corner === 'blue') {
          row.blue = side;
        } else if (corner === 'red') {
          row.red = side;
        } else {
          // fallback: paritas nomor partai (jarang kepakai)
          const isEven = ((order ?? 0) % 2) === 0;
          if (isEven) row.red = side; else row.blue = side;
        }

        // waktu/score pertama yang ada disimpan
        if (!row.time && m.match_time)   row.time  = m.match_time;
        if (!row.score && m.final_score) row.score = m.final_score;
      }
    }
  }

  // hasil akhir: array urut by order ASC
  return Array.from(byOrder.values()).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
},



    // === Untuk BATTLE: kembalikan array group per babak, setiap group punya rows terurut
    // dan kolom display_no (1..N) lokal per tabel babak tsb.
    buildBattleGroups(matches = []) {
      // Pair per battle_group
      const byGroup = new Map(); // battle_group -> row

      for (const m of (matches || [])) {
        const g = m.battle_group ?? m.match_order ?? m.id;
        if (!byGroup.has(g)) {
          byGroup.set(g, {
            key: `g-${g}`,
            // tetap simpan order global untuk sort (biar urut eksekusi asli)
            order: (m.order ?? m.match_order ?? Number.MAX_SAFE_INTEGER),
            round_label: m.round_label || '-',
            blue: { contingent: '-', names: '' },
            red:  { contingent: '-', names: '' },
            time: m.match_time ?? null,
            score: m.final_score ?? null,
          });
        }

        const row = byGroup.get(g);

        const names = [
          m.team_member1?.name,
          m.team_member2?.name,
          m.team_member3?.name,
        ].filter(Boolean).join(', ');

        const roundNum  = Number(m.round || 1);
        const namesStr  = names || (roundNum === 1 ? 'BYE' : 'TBD');
        const cont      = m.contingent?.name || '-';
        const corner    = (m.corner || '').toLowerCase();

        if (corner === 'blue') {
          row.blue = { contingent: cont, names: namesStr };
        } else if (corner === 'red') {
          row.red = { contingent: cont, names: namesStr };
        } else {
          // fallback (kalau corner belum ada): tebak parity
          const isEven = ((m.match_order ?? 0) % 2) === 0;
          if (isEven) row.red = { contingent: cont, names: namesStr };
          else        row.blue = { contingent: cont, names: namesStr };
        }

        // ambil order minimum dalam satu group
        const candOrder = (m.order ?? m.match_order ?? Number.MAX_SAFE_INTEGER);
        if (candOrder < row.order) row.order = candOrder;

        // rapihkan label
        if ((!row.round_label || row.round_label === '-') && m.round_label) {
          row.round_label = m.round_label;
        }

        if (!row.time && m.match_time)   row.time  = m.match_time;
        if (!row.score && m.final_score) row.score = m.final_score;
      }

      // rows (tiap pasangan) urutkan by order global
      const rows = Array.from(byGroup.values()).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

      // group per round_label
      const bucket = new Map(); // label -> { label, rows: [], minOrder }
      for (const r of rows) {
        const label = r.round_label || '-';
        if (!bucket.has(label)) bucket.set(label, { label, rows: [], minOrder: Number.MAX_SAFE_INTEGER });
        bucket.get(label).rows.push(r);
        bucket.get(label).minOrder = Math.min(bucket.get(label).minOrder, (r.order ?? Number.MAX_SAFE_INTEGER));
      }

      // urutkan row di dalam babak & assign display_no lokal (1..N)
      const grouped = Array.from(bucket.values())
        .sort((a, b) => a.minOrder - b.minOrder) // Semifinal (min order kecil) muncul duluan ketimbang Final, dst
        .map(g => {
          g.rows.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
          g.rows = g.rows.map((r, i) => ({ ...r, display_no: i + 1 })); // nomor lokal
          return g;
        });

      return grouped;
    },

    // === Untuk NON-BATTLE: kembalikan matches yang sudah disort + display_no lokal (1..N)
    getNonBattleTables(groupList = []) {
      const tables = [];

      (groupList || []).forEach(cg => {
        (cg.pools || []).forEach(pool => {
          const age = pool?.matches?.[0]?.pool?.age_category?.name || '-';

          // ambil hanya non-battle, sort by order/match_order, lalu nomor lokal 1..N
          const rows = (pool.matches || [])
            .filter(m => m?.mode !== 'battle')
            .sort((a, b) =>
              (a.match_order ?? a.order ?? 0) - (b.match_order ?? b.order ?? 0)
            )
            .map((m, i) => ({ ...m, display_no: i + 1 }));

          if (rows.length > 0) {
            tables.push({
              /*
               * Gender tidak lagi ikut jadi kunci maupun judul.
               *
               * Kalau satu pool berisi peserta putra dan putri sekaligus,
               * keduanya kini masuk ke tabel yang sama — dan memang begitu
               * seharusnya: yang memisahkan penampilan adalah pool dan
               * kategorinya, bukan gender.
               */
              key: `${cg.category}|${age}|${pool.name}`,
              title: {
                category: cg.category,
                age,
                pool: pool.name,
              },
              rows,
            });
          }
        });
      });

      return tables;
    },

    getAthleteColspan(tb) {
      const type = tb?.rows?.[0]?.match_type;
      if (type === 'seni_regu') return 3;
      if (type === 'seni_ganda') return 2;
      return 1;
    },

    getPoolColspan(tb) {
      return 2 + this.getAthleteColspan(tb);
    },

    // Tetap dipakai di non-battle kalau kamu butuh versi baris lokal
    getNonBattleRows(matches = []) {
      const sorted = [...matches].sort((a, b) => {
        const oa = a.match_order ?? a.order ?? 0;
        const ob = b.match_order ?? b.order ?? 0;
        if (oa !== ob) return oa - ob;
        return (a.id ?? 0) - (b.id ?? 0);
      });
      return sorted.map((m, i) => ({ ...m, display_no: i + 1 }));
    },




      
    

      /**
       * Build baris battle dari daftar match (blue+red dalam satu baris),
       * dikelompokkan berdasarkan (round, battle_group).
       */
      buildBattleRows(matches = []) {
        const groups = {};

        matches.forEach(m => {
          if (m?.mode !== 'battle') return;
          const gkey = `${m.round || 1}-${m.battle_group || m.match_order || 0}`;

          if (!groups[gkey]) {
            groups[gkey] = {
              order: m.match_order ?? null,
              round_label: m.round_label ?? null,
              blue: null,
              red: null,
              time: m.match_time ?? null,
              score: m.final_score ?? null,
            };
          }

          // Keep the earliest filled info (order/time/label)
          if (!groups[gkey].order && m.match_order) groups[gkey].order = m.match_order;
          if (!groups[gkey].round_label && m.round_label) groups[gkey].round_label = m.round_label;
          if (!groups[gkey].time && m.match_time) groups[gkey].time = m.match_time;
          if (!groups[gkey].score && m.final_score) groups[gkey].score = m.final_score;

          if (m.corner === 'blue') groups[gkey].blue = m;
          if (m.corner === 'red')  groups[gkey].red  = m;
        });

        // Convert ke array + sort by order lalu round
        return Object.entries(groups)
          .map(([key, g]) => ({
            key,
            order: g.order,
            round_label: g.round_label,
            time: g.time,
            score: g.score,
            blue: {
              contingent: g.blue?.contingent?.name || (g.blue?.contingent_name ?? null),
              names: this._joinMemberNames(g.blue),
            },
            red: {
              contingent: g.red?.contingent?.name || (g.red?.contingent_name ?? null),
              names: this._joinMemberNames(g.red),
            },
          }))
          .sort((a, b) => {
            // primary by order, secondary by round label (optional)
            const ao = a.order ?? 0, bo = b.order ?? 0;
            if (ao !== bo) return ao - bo;
            return String(a.round_label || '').localeCompare(String(b.round_label || ''));
          });
      },

    downloadSchedule(arena, date) {
      const params = new URLSearchParams({
        arena_name: arena.arena_name,
        scheduled_date: date,
        _t: Date.now(),
      });

      const url = `${API.API_BASE_URL}/seni/export-schedule?${params.toString()}`;
      window.open(url, '_blank');
    },



    formatLongDate(dateStr) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateStr).toLocaleDateString('id-ID', options);
    },
    formatShortDate(dateStr) {
      const date = new Date(dateStr);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },

    kosongkanSaring() {
      this.filterTanggal = '';
      this.filterKategori = '';
      this.filterArena = '';
      this.filterPool = '';
    },

    async fetchSchedules() {
      this.memuat = true;
      this.galat = null;

      try {
        const slug = this.slugAktif;

        if (!slug) {
          this.scheduleData = [];
          return;
        }

        const response = await axios.get(`/tournaments/${slug}/match-schedules/seni`);
        this.scheduleData = Array.isArray(response.data?.data) ? response.data.data : [];

        /*
         * `?? []` di tiap tingkat, bukan hiasan.
         *
         * Versi sebelumnya menulis `entry.groups.forEach(...)` langsung. Satu
         * entri tanpa `groups` cukup untuk melempar TypeError, yang lalu
         * ditangkap catch di bawah dan mengosongkan SELURUH jadwal — bukan
         * cuma entri yang bermasalah. Kegagalan sekecil apa pun jadi terlihat
         * sebagai "tidak ada jadwal sama sekali".
         */
        const pools = new Set();
        this.scheduleData.forEach(entry => {
          (entry.groups ?? []).forEach(group => {
            (group.pools ?? []).forEach(pool => {
              if (pool.name) pools.add(pool.name);
            });
          });
        });

        this.allDates = [...new Set(this.scheduleData.map(i => i.scheduled_date).filter(Boolean))];
        this.allArenaNames = [...new Set(this.scheduleData.map(i => i.arena_name).filter(Boolean))];
        this.allPoolNames = [...pools];

        // Pilihan milik acara sebelumnya dilepas saat berpindah acara.
        if (this.filterTanggal && !this.allDates.includes(this.filterTanggal)) this.filterTanggal = '';
        if (this.filterArena && !this.allArenaNames.includes(this.filterArena)) this.filterArena = '';
        if (this.filterPool && !this.allPoolNames.includes(this.filterPool)) this.filterPool = '';
        if (this.filterKategori && !this.allCategories.includes(this.filterKategori)) this.filterKategori = '';
      } catch (error) {
        console.error('Gagal ambil data jadwal seni:', error);
        this.scheduleData = [];
        this.galat = error?.response?.data?.message || error?.message || 'Gagal memuat jadwal seni.';
      } finally {
        this.memuat = false;
      }
    },
    downloadPDF() {
      const element = this.$refs.printArea;
      const options = {
        filename: 'jadwal-pertandingan.pdf',
        margin: 0.3,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };
      html2pdf().set(options).from(element).save();
    }
  },
};
</script>

<style scoped>
/* Penyaring: satu baris yang membungkus sendiri di layar sempit. */
.jadwal-saring-baris {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
}

.jadwal-saring-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1 175px;
  min-width: 150px;
  font-size: 0.9rem;
}

.jadwal-saring-reset { flex: 0 0 auto; }

/*
 * Gaya halaman ini dipindah ke src/assets/css/jadwal.css.
 * Alasannya: kelima halaman jadwal menyalin blok yang sama persis, sehingga
 * setiap perbaikan harus dikerjakan lima kali dan mudah tertinggal di salah
 * satunya. Berkas bersama juga tidak "scoped", jadi ia sanggup menjangkau
 * tabel Bootstrap yang dirender di dalam komponen anak.
 */
</style>
